import Image from "next/image";

import { StepsCta } from "@/components/homepage/steps-cta";
import { IMAGE_QUALITY, IMAGE_SIZES_PRESETS } from "@/lib/images/image-config";

const STEPS = [
  { numeral: "1.", text: "Crie sua conta e conheça todos os benefícios de ter uma Lista de Casamento Tania Bulhões." },
  {
    numeral: "2.",
    text: "Escolha livremente entre nossas peças e crie uma seleção que traduza o estilo de vocês. Depois, compartilhe o link com seus convidados.",
  },
  {
    numeral: "3.",
    text: "A cada presente recebido, vocês são avisados e podem acompanhar a evolução da lista pelo seu painel exclusivo.",
  },
  { numeral: "4.", text: "Resgate seus presentes quando quiser: retire em uma de nossas lojas ou receba no conforto de casa." },
] as const;

/**
 * "Como montar a sua lista" — account, curation, tracking, redemption.
 *
 * Split layout: copy left, photo right from 900px up, stacked below. Like the
 * other content sections, the four steps are in code for the MVP (Tech Spec
 * § Origem do conteúdo).
 */
export function StepsSection() {
  return (
    <section
      id="como"
      className="grid grid-cols-1 bg-[var(--tb-white)] [@media(min-width:900px)]:grid-cols-2"
    >
      <div className="flex flex-col justify-center gap-[clamp(28px,3.4vw,44px)] px-[clamp(32px,6vw,96px)] py-[clamp(56px,8vw,120px)]">
        <div className="flex flex-col gap-[30px]">
          <span className="text-[15px] font-medium uppercase tracking-[0.16em] text-tb-green">Como montar a sua lista</span>
          <h2 className="font-display text-[clamp(28px,3.17vw,44px)] font-light uppercase leading-[var(--tb-typography-line-height-display)] tracking-[-0.01em] [text-wrap:balance]">
            Sua lista, do seu <span className="text-tb-green">jeito</span>.
          </h2>
        </div>

        <div className="flex flex-col">
          {STEPS.map((step) => (
            <div
              key={step.numeral}
              className="flex items-start gap-4 border-t border-[var(--tb-hairline)] py-[clamp(20px,2.2vw,28px)] [@media(min-width:900px)]:gap-[clamp(20px,2.2vw,38px)]"
            >
              <span className="w-[34px] flex-none font-display text-[30px] font-medium leading-none text-tb-green [@media(min-width:900px)]:w-[46px] [@media(min-width:900px)]:text-[clamp(36px,3.6vw,50px)]">
                {step.numeral}
              </span>
              <p className="[@media(min-width:900px)]:max-w-[440px] text-[clamp(15px,1.02vw,16px)] leading-[1.62] text-[var(--fg-muted)]">
                {step.text}
              </p>
            </div>
          ))}
        </div>

        {/* See `what-is-section` — same editorial CTA overrides. */}
        <StepsCta />
      </div>

      {/* The min-height applies at every width, not just from 900px up: stacked
          below the copy the photo still needs its own band, or `fill` collapses
          to nothing. */}
      <div className="relative min-h-[clamp(400px,64svh,860px)] overflow-hidden">
        {/* Two crops, as the reference ships them: a wide one, and a tall one for a phone. */}
        <Image
          src="/images/homepage/como-montar-mobile.jpg"
          alt="Como montar sua lista"
          fill
          // Shown only below 900px, where the photo is stacked under the copy: the full width.
          sizes={IMAGE_SIZES_PRESETS.fullBleed}
          quality={IMAGE_QUALITY.default}
          className="object-cover [@media(min-width:900px)]:hidden"
        />
        <Image
          src="/images/homepage/como-montar.jpg"
          alt="Como montar sua lista"
          fill
          sizes={IMAGE_SIZES_PRESETS.splitFromDesktop}
          quality={IMAGE_QUALITY.default}
          className="hidden object-cover [@media(min-width:900px)]:block"
        />
      </div>
    </section>
  );
}
